import React from 'react'
import Todo from '../Components/Todo/Todo'

function HomePage() {
  return (
    <Todo/>
  )
}

export default HomePage